import { ThemeComponent } from "@/theme/ThemeComponent";
import { html, render } from "lit-html";
import { cart } from "@/theme/Cart";
import { CartItem, Component, dump, Prop, Ref } from '@eastsideco/salvo-ts';
import { QuantitySpinner } from "../QuantitySpinner/QuantitySpinner";
import { CartMain } from "../Cart/CartMain";
import { NotificationMessage } from "../NotificationMessage/NotificationMessage";
import { formatPrice} from "@/utils/products";
import { formatMoney } from '@/utils/formatting';

@Component
export class CartItemRow extends ThemeComponent {
    private quantity: QuantitySpinner;
    private lineQuantity: number;
    private cartMain: CartMain;

    constructor(item: CartItem, quantity: QuantitySpinner, strings: string) {
        super();
        this.quantity = quantity;
        this.render(item, quantity, strings);
        this.lineQuantity = item.quantity;
        this.cartMain = document.querySelector('cart-main') as CartMain;
    }

    render(item: CartItem, quantity: QuantitySpinner, strings: string) {
        /* eslint-disable */
        render(html`
            <div class="cart-row">
                <div class="cart-row__image-wrapper">
                    <a href="${item.url}" class="cart-row__image object-cover">
                        <img src="${item.image}" alt="${item.title}">
                        ${item.properties && item.properties['_stock-alert'] ? this.renderStockAlert() : ''}
                    </a>
                </div>
                <div class="cart-row__information">
                    <div class="cart-row__info-top">
                        <div class="cart-row__brand">
                            ${item.vendor}
                            ${item.properties &&
                                item.properties['_parent-category'] ? this.renderParentCategory(item) : ''}
                        </div>
                        <div class="cart-row__title">${item.title}</div>
                        
                        ${item.optionsWithValues.map((option) => html`<div class="cart-row__option">${option.name !== 'Title' ? `${option.name}: ${option.value}` : ''}</div>`)}
                        
                        ${item.properties &&
                            item.properties['_linked-product-name'] ? this.renderLinkedProductName(item) : ''}
                    </div>

                    <div class="cart-row__info-bottom">

                    </div>
                </div>

                <div class="cart-row__details-wrapper">
                    <div class="cart-row__details">

                        <div class="cart-row__detail cart-row__price">
                            ${formatPrice(item.price, String(JSON.parse(strings).moneyFormat))}
                        </div>

                        <div class="cart-row__detail cart-row__quantity body-xsmall" data-id="${item.id}">
                            ${quantity}
                        </div>

                        <div class="cart-row__detail cart-row__total">
                            ${formatMoney(item.linePrice)}
                        </div>

                        <div class="cart-row__detail cart-row__update">
                            <button 
                                class="cart-row__remove meta" 
                                data-ref="removeItem" 
                                data-item="${item.variantId}"
                            >
                                ${JSON.parse(strings).remove}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        `, this);
        /* eslint-enable */
    }

    renderParentCategory(item: CartItem) {
        return html`<span class="cart-row__parent-category">${item.properties['_parent-category']}</span>`;
    }

    renderLinkedProductName(item: CartItem) {
        const swatchColour = item.properties && item.properties['_swatch-colour'] ? this.renderSwatch(item) : null;
        return html`
            <div class="cart-row__colour">
                <span>Colour:</span>
                ${swatchColour ? swatchColour : ''}
                <span class="cart-row__linked-product-name">${item.properties['_linked-product-name']}</span>
            </div>
        `;
    }

    renderSwatch(item: CartItem) {
        return html`
            <span
                class="cart-row__swatch"
                style="background-color: ${item.properties['_swatch-colour']};"
            >
            </span>`;
    }

    renderOptionsWithValues(item: CartItem) {
        const optionMarkupArray = item.optionsWithValues.map((option) => `<div>${option.name}: ${option.value}</div>`);
        const optionMarkup = optionMarkupArray.join();

        return optionMarkup;
    }

    /* eslint-disable */
    renderStockAlert() {
        return html`
            <div class="cart-row__stock-alert-wrapper">
                <div class="cart-row__stock-alert">
                    <svg width="8" height="9.3" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M11.26 5.36665C11.2046 5.25671 11.1198 5.16426 11.0151 5.09954C10.9104 5.03482 10.7898 5.00036 10.6667 4.99999H7.33333V0.999988C7.34049 0.853777 7.29932 0.709276 7.21618 0.588788C7.13305 0.468301 7.01256 0.378526 6.87333 0.333321C6.73948 0.289283 6.59512 0.288789 6.46097 0.331908C6.32683 0.375027 6.20979 0.459542 6.12667 0.573321L0.793333 7.90665C0.72651 8.00323 0.686385 8.11575 0.67702 8.23282C0.667654 8.34988 0.68938 8.46735 0.739999 8.57332C0.786614 8.69449 0.867591 8.79941 0.972992 8.8752C1.07839 8.95099 1.20363 8.99436 1.33333 8.99999H4.66667V13C4.66677 13.1406 4.71131 13.2775 4.79393 13.3913C4.87655 13.505 4.99301 13.5897 5.12667 13.6333C5.19365 13.6541 5.26322 13.6653 5.33333 13.6667C5.43852 13.6669 5.54229 13.6423 5.63614 13.5948C5.72999 13.5473 5.81127 13.4783 5.87333 13.3933L11.2067 6.05999C11.2785 5.96052 11.3215 5.84316 11.3309 5.72083C11.3403 5.59849 11.3158 5.47594 11.26 5.36665ZM6 10.9467V8.33332C6 8.15651 5.92976 7.98694 5.80474 7.86192C5.67971 7.73689 5.51014 7.66665 5.33333 7.66665H2.66667L6 3.05332V5.66665C6 5.84347 6.07024 6.01303 6.19526 6.13806C6.32029 6.26308 6.48986 6.33332 6.66667 6.33332H9.33333L6 10.9467Z" fill="#B65B07"/>
                    </svg>
                    Only 1 left!
                </div>
            </div>
        `;
    }
    /* eslint-enable */

    displayNotification(message: string, type: string) {
        // If an error occurs specific to a cart row,
        // display an error beneath the row
        if (!message) {
            return;
        }

        // Get the containing cart
        if (this.cartMain) {
            this.cartMain.insertAdjacentHTML('beforebegin', `
                <notification-message
                    class="notification-message
                    notification-message--${type}"
                    timed="true"
                >
                    ${message}
                </notification-message>
            `);
        }

    }

    @Ref() removeItem!: HTMLButtonElement;

    /**
     * Initialise.
     */
    init() {
        this.$listen(this.removeItem, 'click', () => this.handleRemoveItem(this.removeItem));
        this.$subscribe(this.quantity.onChange, (value) => this.handleQuantity(value));
    }

    /**
     * Remove item from cart.
     * @param target - remove button.
     */
    handleRemoveItem(target: HTMLElement) {
        if (target.dataset.item === undefined) { return; }

        for (const item of cart.items) {
            if (~~item.id === ~~target.dataset.item) {
                try {
                    cart.removeItem(item).catch((event: unknown) => {
                        if (event instanceof Error) {
                            this.$log.error(event.message);
                        }
                    });

                } catch (event: unknown) {
                    if (event instanceof Error) {
                        this.$log.info('Remove error', event.message);
                    }
                }
            }
        }
    }

    /**
     * Handle cart quantity change.
     */
    handleQuantity(value: number) {
        if(this.quantity === null || this.quantity.parentNode === null ) { return; }

        if (this.quantity.parentNode instanceof HTMLElement) {
            if(this.quantity.parentNode.dataset.id == null) { return; }
            const itemId = this.quantity.parentNode.dataset.id;

            for (const item of cart.items) {
                if (+item.id === +itemId) {
                    const quantity = +this.quantity.input.value;


                    cart.changeItem(item, quantity, null).then((event) => {
                        this.lineQuantity = value;
                    }).catch((event: unknown) => {
                        if (event instanceof Error) {
                            this.quantity.input.value = String(this.lineQuantity);
                            this.$log.error(event.message);
                            this.displayNotification(event.message, "error");
                        }
                    });

                }
            }
        }
    }
}

